import './locale.config';

import { enableProdMode, LOCALE_ID } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: 'https://7a3627ffae2ab59a9d64c5ee501805db@sentry.hamel.construction/3',
  environment: environment.environmentName,
  sendDefaultPii: true,
  enableLogs: true,
  tunnel: environment.apiBaseUrl + 'sentry/tunnel',
  beforeSendLog: (log) => {
    if (log.message.startsWith('NG') || log.message.startsWith('Init') || log.message.startsWith('SDB')) {
      return null;
    }
    return log;
  },
  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.browserTracingIntegration(),
    Sentry.feedbackIntegration({
      autoInject: false,
      colorScheme: 'system',
      triggerLabel: '',
      triggerAriaLabel: 'Signaler un bug',
      formTitle: 'Signaler un bug',
      submitButtonLabel: 'Envoyer le rapport de bug',
      cancelButtonLabel: 'Annuler',
      confirmButtonLabel: 'Confirmer',
      addScreenshotButtonLabel: 'Ajouter une capture d\'écran',
      removeScreenshotButtonLabel: 'Retirer la capture d\'écran',
      nameLabel: 'Numéro d\'employé',
      namePlaceholder: 'Votre nom',
      emailLabel: 'Courriel',
      emailPlaceholder: 'votre.courriel@exemple.org',
      isRequiredLabel: '(obligatoire)',
      messageLabel: 'Description',
      messagePlaceholder: 'Quel est le bug ? Qu’attendiez-vous ?',
      successMessageText: 'Merci pour votre signalement!',
      highlightToolText: 'Surligner',
      hideToolText: 'Masquer',
      removeHighlightText: 'Retirer',
    }),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/sihc.hamelconstruction.com\/SIHC.Service\//],
});

platformBrowserDynamic([{ provide: LOCALE_ID, useValue: 'fr-CA' }])
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
